import React from 'react';

export const WhySection = ({ t }) => {
  return (
    <section className="section-padding section-grey border-t border-gray-200 relative">
      {/* Structural grid lines */}
      <div className="absolute left-1/4 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gray-200 to-transparent opacity-50" />
      <div className="absolute left-3/4 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gray-200 to-transparent opacity-50" />
      
      <div className="container mx-auto px-8 max-w-7xl">
        <div className="grid md:grid-cols-12 gap-16">
          {/* Left column - Title */}
          <div className="md:col-span-4">
            <p className="text-xs text-gray-400 uppercase tracking-widest mb-8 font-light">{t.why.label}</p>
            <h2 className="text-6xl md:text-7xl font-normal text-gray-900 mb-10 leading-tight tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {t.why.title1}<br />{t.why.title2}
            </h2>
            <div className="w-20 h-px bg-gray-300" />
          </div>

          {/* Right column - Content */}
          <div className="md:col-span-8 space-y-12">
            {t.why.principles.map((principle, index) => (
              <div 
                key={index}
                className="flex items-start gap-10 pb-12 border-b border-gray-300 last:border-0 relative"
              >
                {/* Structural element */}
                <div className="absolute left-0 top-0 w-12 h-px bg-gray-400" />
                
                <span className="text-gray-300 font-light text-2xl mt-2 flex-shrink-0 w-16 tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  0{index + 1}
                </span>
                <p className="text-2xl text-gray-800 font-light leading-relaxed pt-1">
                  {principle}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
